import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
var containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    marginTop: 50,
};
var HowTo = function () {
    return (_jsx(Grid, { style: containerStyle, spacing: 2, children: _jsx(Grid, { size: { lg: 6, sm: 12 }, children: _jsx(Typography, { variant: 'h4', children: "How To Use Huddle Maps" }) }) }));
};
export default HowTo;
